<template>
  <div class="container home page">
    <div class="row">
      <div class="body-pane col-lg-8">
        <div class="content">
          <hgroup>
            <h2>Contact Me</h2>
          </hgroup>
          <p>You can email me directly at: <strong>rh (at symbol) rhwk.me</strong></p>
          <p><a href="https://www.linkedin.com/in/rhwk/">LinkedIn Profile</a></p>
        </div>
      </div>
      <div class="aux col-lg-4">
        <div class="ad">
          <h3>NOW AVAILABLE EVERYWHERE MUSIC IS STREAMED</h3>
          <img src="../assets/Rhystron-CD-2.webp" width="100%" alt="Rhystron album cover: There'll Be No Mercy" />
        </div>

        <div class="ad">
          <h3>PREVIOUS RELEASE</h3>
          <img src="../assets/Rhystron-CD-UiB.webp" width="100%" alt="Rhystron album cover: Ugly in Blue" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactView',
}
</script>
